var map = {
	"./adb": 3374,
	"./adb.ts": 3374,
	"./apt": 28,
	"./apt.ts": 28,
	"./basename": 5941,
	"./basename.ts": 5941,
	"./brew": 8507,
	"./brew.ts": 8507,
	"./bundle": 2315,
	"./bundle.ts": 2315,
	"./cat": 6519,
	"./cat.ts": 6519,
	"./chmod": 6190,
	"./chmod.ts": 6190,
	"./chown": 6074,
	"./chown.ts": 6074,
	"./clear": 6730,
	"./clear.ts": 6730,
	"./cp": 8024,
	"./cp.ts": 8024,
	"./curl": 6733,
	"./curl.ts": 6733,
	"./cut": 8595,
	"./cut.ts": 8595,
	"./date": 5879,
	"./date.ts": 5879,
	"./dd": 6323,
	"./dd.ts": 6323,
	"./df": 3173,
	"./df.ts": 3173,
	"./diff": 4248,
	"./diff.ts": 4248,
	"./dig": 1107,
	"./dig.ts": 1107,
	"./dirname": 6355,
	"./dirname.ts": 6355,
	"./docker": 1991,
	"./docker-compose": 70,
	"./docker-compose.ts": 70,
	"./docker.ts": 1991,
	"./dotnet": 1525,
	"./dotnet.ts": 1525,
	"./du": 628,
	"./du.ts": 628,
	"./echo": 8386,
	"./echo.ts": 8386,
	"./env": 3780,
	"./env.ts": 3780,
	"./export": 1577,
	"./export.ts": 1577,
	"./fdisk": 1616,
	"./fdisk.ts": 1616,
	"./find": 5220,
	"./find.ts": 5220,
	"./fmt": 1380,
	"./fmt.ts": 1380,
	"./fold": 6912,
	"./fold.ts": 6912,
	"./go": 6969,
	"./go.ts": 6969,
	"./grep": 6707,
	"./grep.ts": 6707,
	"./head": 6709,
	"./head.ts": 6709,
	"./htop": 8920,
	"./htop.ts": 8920,
	"./id": 1822,
	"./id.ts": 1822,
	"./jq": 3578,
	"./jq.ts": 3578,
	"./kill": 4228,
	"./kill.ts": 4228,
	"./killall": 1636,
	"./killall.ts": 1636,
	"./less": 9578,
	"./less.ts": 9578,
	"./ln": 1765,
	"./ln.ts": 1765,
	"./ls": 346,
	"./ls.ts": 346,
	"./lsblk": 1963,
	"./lsblk.ts": 1963,
	"./lsof": 4591,
	"./lsof.ts": 4591,
	"./mkdir": 3016,
	"./mkdir.ts": 3016,
	"./more": 8490,
	"./more.ts": 8490,
	"./mount": 5554,
	"./mount.ts": 5554,
	"./mv": 4640,
	"./mv.ts": 4640,
	"./nano": 1485,
	"./nano.ts": 1485,
	"./nl": 785,
	"./nl.ts": 785,
	"./node": 1375,
	"./node.ts": 1375,
	"./npm": 5234,
	"./npm.ts": 5234,
	"./nvm": 1056,
	"./nvm.ts": 1056,
	"./od": 5160,
	"./od.ts": 5160,
	"./paste": 2500,
	"./paste.ts": 2500,
	"./ping": 8955,
	"./ping.ts": 8955,
	"./pkill": 7755,
	"./pkill.ts": 7755,
	"./pnpm": 8110,
	"./pnpm.ts": 8110,
	"./ps": 3150,
	"./ps.ts": 3150,
	"./pwd": 5860,
	"./pwd.ts": 5860,
	"./python": 7421,
	"./python.ts": 7421,
	"./python3": 3460,
	"./python3.ts": 3460,
	"./readlink": 4979,
	"./readlink.ts": 4979,
	"./rm": 6950,
	"./rm.ts": 6950,
	"./rmdir": 4327,
	"./rmdir.ts": 4327,
	"./rsync": 9210,
	"./rsync.ts": 9210,
	"./ruby": 5883,
	"./ruby.ts": 5883,
	"./ruff": 7062,
	"./ruff.ts": 7062,
	"./scp": 3513,
	"./scp.ts": 3513,
	"./sed": 4163,
	"./sed.ts": 4163,
	"./seq": 1848,
	"./seq.ts": 1848,
	"./shred": 2441,
	"./shred.ts": 2441,
	"./sort": 5507,
	"./sort.ts": 5507,
	"./source": 8990,
	"./source.ts": 8990,
	"./split": 1219,
	"./split.ts": 1219,
	"./ssh": 2449,
	"./ssh.ts": 2449,
	"./stat": 3502,
	"./stat.ts": 3502,
	"./su": 7939,
	"./su.ts": 7939,
	"./sudo": 7110,
	"./sudo.ts": 7110,
	"./tac": 8223,
	"./tac.ts": 8223,
	"./tail": 9197,
	"./tail.ts": 9197,
	"./tar": 2816,
	"./tar.ts": 2816,
	"./tee": 457,
	"./tee.ts": 457,
	"./time": 1970,
	"./time.ts": 1970,
	"./top": 1012,
	"./top.ts": 1012,
	"./touch": 5476,
	"./touch.ts": 5476,
	"./tr": 1033,
	"./tr.ts": 1033,
	"./traceroute": 8045,
	"./traceroute.ts": 8045,
	"./tree": 6479,
	"./tree.ts": 6479,
	"./truncate": 8697,
	"./truncate.ts": 8697,
	"./uname": 1799,
	"./uname.ts": 1799,
	"./uniq": 4058,
	"./uniq.ts": 4058,
	"./unzip": 2945,
	"./unzip.ts": 2945,
	"./vim": 4180,
	"./vim.ts": 4180,
	"./wc": 9661,
	"./wc.ts": 9661,
	"./wget": 8632,
	"./wget.ts": 8632,
	"./where": 4632,
	"./where.ts": 4632,
	"./whereis": 2488,
	"./whereis.ts": 2488,
	"./which": 8934,
	"./which.ts": 8934,
	"./who": 4783,
	"./who.ts": 4783,
	"./xargs": 3574,
	"./xargs.ts": 3574,
	"./xxd": 7171,
	"./xxd.ts": 7171,
	"./yarn": 2961,
	"./yarn.ts": 2961,
	"./yo": 1371,
	"./yo.ts": 1371,
	"./zip": 5416,
	"./zip.ts": 5416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4534;